var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAttempt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24845_14965)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 6,
    height: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0.28125C3.2879 0.28125 0.279297 3.28985 0.279297 7.00125C0.279205 7.88385 0.452978 8.75783 0.790693 9.57326C1.12841 10.3887 1.62345 11.1296 2.24754 11.7537C2.87163 12.3778 3.61255 12.8728 4.42799 13.2106C5.24342 13.5483 6.1174 13.722 7 13.722C10.7107 13.722 13.72 10.7134 13.72 7.00125C13.72 3.28985 10.7107 0.28125 7 0.28125ZM7.6272 2.70745C8.2824 2.70745 8.4749 3.08755 8.4749 3.52225C8.4749 4.06475 8.0409 4.56665 7.2996 4.56665C6.6794 4.56665 6.384 4.25515 6.4022 3.73925C6.4022 3.30455 6.7655 2.70745 7.6272 2.70745ZM5.9486 11.0263C5.5006 11.0263 5.1737 10.754 5.4866 9.56045L5.9997 7.44295C6.0886 7.10415 6.1033 6.96835 5.9997 6.96835C5.866 6.96835 5.2843 7.20215 4.9413 7.43315L4.718 7.06705C5.8065 6.15775 7.0581 5.62435 7.5936 5.62435C8.0416 5.62435 8.1158 6.15355 7.8925 6.96835L7.3045 9.19435C7.2002 9.58775 7.245 9.72355 7.3493 9.72355C7.4837 9.72355 7.9233 9.56115 8.3559 9.22025L8.6093 9.56045C7.5502 10.6189 6.3959 11.0263 5.9486 11.0263Z",
    fill: "#5BB1FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24845_14965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAttempt);
export default __webpack_public_path__ + "static/media/InfoAttempt.7a6d4c7539198819a0e391574ed2fc42.svg";
export { ForwardRef as ReactComponent };